var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarnsmission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.57,
    height: 73.691,
    viewBox: "0 0 77.57 73.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "noun-transmission-2531567",
    transform: "translate(-2 -2)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M69.874,2H11.7A9.708,9.708,0,0,0,2,11.7V66a9.706,9.706,0,0,0,9.7,9.7H69.874a9.706,9.706,0,0,0,9.7-9.7V11.7a9.708,9.708,0,0,0-9.7-9.7Zm5.818,64a5.824,5.824,0,0,1-5.818,5.818H11.7A5.824,5.824,0,0,1,5.878,66V11.7A5.824,5.824,0,0,1,11.7,5.878H69.874A5.824,5.824,0,0,1,75.691,11.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M51.542,28.289V16.3a5.818,5.818,0,1,0-3.878,0V28.289H32.15V16.3a5.818,5.818,0,1,0-3.878,0V28.289H14.7a1.941,1.941,0,0,1-1.939-1.939V16.3a5.818,5.818,0,1,0-3.878,0V26.35A5.824,5.824,0,0,0,14.7,32.168H28.271V44.16a5.818,5.818,0,1,0,3.878,0V32.168H47.664V44.16a5.818,5.818,0,1,0,3.879,0ZM49.6,8.9a1.939,1.939,0,1,1-1.939,1.939A1.939,1.939,0,0,1,49.6,8.9Zm-19.392,0a1.939,1.939,0,1,1-1.939,1.939A1.939,1.939,0,0,1,30.211,8.9Zm-19.392,0a1.939,1.939,0,1,1-1.939,1.939A1.939,1.939,0,0,1,10.818,8.9ZM30.211,51.56a1.939,1.939,0,1,1,1.939-1.939A1.939,1.939,0,0,1,30.211,51.56Zm19.392,0a1.939,1.939,0,1,1,1.939-1.939A1.939,1.939,0,0,1,49.6,51.56Z",
    transform: "translate(8.635 8.617)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarnsmission);
export default __webpack_public_path__ + "static/media/tarnsmission.e9724a160c4c135df9700689a6d5ccfd.svg";
export { ForwardRef as ReactComponent };